import * as Yup from "yup";

export const ValidateSchema = Yup.object({
  aeroplanNumber: Yup.string().required("validate.block-form.error.aeroplannumber-required")
  .matches(/^[0-9]+$/, "validate.block-form.error.aeroplannumber-numeric")
  .min(9, "validate.block-form.error.aeroplannumber-digits")
  .max(9, "validate.block-form.error.aeroplannumber-digits"),
  lastName: Yup.string().required("validate.block-form.error.lastname-required"),
});
